import { render } from "./ProfileChangeName.vue?vue&type=template&id=b46a8164"
import script from "./ProfileChangeName.vue?vue&type=script&lang=js"
export * from "./ProfileChangeName.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__